export default __webpack_public_path__ + "a7d78834de542283ef4d9e819d121f39.svg";